import { render } from "./HochschuleDetails.pug?vue&type=template&id=601bbc1a&lang=pug"
import script from "./HochschuleDetails.js?vue&type=script&lang=js"
export * from "./HochschuleDetails.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__